import { render, staticRenderFns } from "./ProfileNavigation.vue?vue&type=template&id=105faa62&scoped=true&"
import script from "./ProfileNavigation.vue?vue&type=script&lang=js&"
export * from "./ProfileNavigation.vue?vue&type=script&lang=js&"
import style0 from "./ProfileNavigation.vue?vue&type=style&index=0&id=105faa62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105faa62",
  null
  
)

export default component.exports